import 'babel-polyfill';
import 'whatwg-fetch';
import App from './components/App';

console.clear();

console.log(
  `%cUnfollow Me.\nA website from broadly.vice.com`,
  'padding: 50px 0; color: #035EDA; font-size: 12px; font-family: Helvetica, sans-serif; font-weight: 700; line-height: 1.4em;'
);

const app = new App();

